import React from "react";
import InternalLayout from "../../../../../../layouts/internalLayout";
import Left from "./left";
import Right from "./right";

const PricingFrameProducts = () => {
  return (
    <>
      <InternalLayout
        pageTitle="Systems"
        layoutType=""
        leftContent={<Left />}
        rightContent={<Right />}
      />
    </>
  );
};

export default PricingFrameProducts;
